import React from "react";
import PropTypes from "prop-types";
import { Popup, Transition, Button } from "semantic-ui-react";

const propTypes = {
  action: PropTypes.func,
  buttonText: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  popup: PropTypes.string
};

const defaultProps = {
  buttonText: null,
  disabled: false,
  icon: null,
  color: "pink",
  size: null,
  popup: null
};

class BotonAnimado extends React.Component {
  state = { visible: true };
  handleClick = () => {
    this.setState(state => ({ visible: !state.visible }));
    this.props.onClick();
  };

  renderPopup = () => (
    <Popup
      content={this.props.popup}
      trigger={
        <Button
          circular={this.props.circular}
          basic={this.props.basic}
          icon={this.props.icon}
          color={this.props.color}
          floated={this.props.floated}
          content={this.props.buttonText}
          onClick={this.handleClick}
          disabled={this.props.disabled}
          size={this.props.size}
        />
      }
    />
  );

  renderButton = () => (
    <Button
      circular={this.props.circular}
      basic={this.props.basic}
      icon={this.props.icon}
      color={this.props.color}
      floated={this.props.floated}
      content={this.props.buttonText}
      onClick={this.handleClick}
      disabled={this.props.disabled}
      size={this.props.size}
    />
  );

  render(props) {
    return (
      <Transition animation="pulse" duration={250} visible={this.state.visible}>
        {this.props.popup ? this.renderPopup() : this.renderButton()}
      </Transition>
    );
  }
}
BotonAnimado.defaultProps = defaultProps;

BotonAnimado.propTypes = propTypes;

export default BotonAnimado;



// WEBPACK FOOTER //
// ./src/pages/shared/botones/BotonAnimado.jsx